export type HubSpotItem = {
  name: string;
  label: string;
};

export type HubSpotItemsResponse = {
  results: HubSpotItem[];
};

export type HubSpotItemsState = {
  items: HubSpotItem[];
  loading: boolean;
  error: { message: string } | null;
};

export type State = {
  contactProperties: HubSpotItemsState;
  customObjectTypes: HubSpotItemsState;
  customObjectProperties: HubSpotItemsState;
};

const createDefaultItemsState = (): HubSpotItemsState => ({
  items: [],
  loading: false,
  error: null,
});

export const defaultState: State = {
  contactProperties: createDefaultItemsState(),
  customObjectTypes: createDefaultItemsState(),
  customObjectProperties: createDefaultItemsState(),
};
